import { LINK_CG_TERMINAL_FORM, LINK_CG_TERM_TAX_FORM } from './form-tcg-types';
import { terminalListWidget } from '../../widgets/terminal-list-widget';
import { cardGroupListWidget } from '../../widgets/cardgroup-list-widget';
import { getParameters } from '../../../helpers/helpers'
import { addTerminalCardGroup } from './linkTerminalCardGroup/add-terminal-cardgroup';
import { searchAvailableItems } from '../form-search';
import { ICardGroupInsertUpdate, ICustomer, ICardGroup } from '../../../models/cardgroup.interface';
import { ITerminal } from '../../../models/terminal.interface';
import { ICardTerminalTaxResponse } from '../../../models/taxes.interface';

/**
 * Displays partner and terminal names for the link card groups and terminals form
 * 
 * @param {ITerminal} terminalData the individual terminal data
 * 
 * @returns void
 */
export const parseTerminalInfo = (data: Array<ITerminal>) => {
  const { partnerName, terminalName } = data[0];

  LINK_CG_TERMINAL_FORM.partnerName.value = partnerName;
  LINK_CG_TERMINAL_FORM.terminalName.value = terminalName;
}

/**
 * Function that displays card group information
 * 
 * @param {ICardGroup} card card group data
 * @param {ICustomer} cust customer data
 */
export const parseCardGroupInfo = (card: Array<ICardGroup>, cust: Array<ICustomer>) => {   
  if ( !Array.isArray(card) ) return;
  const { name: cardGroupName } = card[0];
  const { name: customerName } = cust[0];

  LINK_CG_TERMINAL_FORM.partnerName.value = customerName;
  LINK_CG_TERMINAL_FORM.terminalName.value = cardGroupName;
}

/**
 * Function that displays customer, card group, and terminal information
 * 
 * @param {ICardTerminalTaxResponse} data the linked tax object
 * 
 * @returns void
 */
export const parseTaxInfo = (data: ICardTerminalTaxResponse) => {
  if (Object.keys(data).length === 0) return;
  const { cust, group, terminal } = data.body;
  const { name: CustomerName } = cust[0];
  const { name: CardGroupName } = group[0];
  const { termName } = terminal[0];

  LINK_CG_TERM_TAX_FORM.cgTTcustomer.value = CustomerName;
  LINK_CG_TERM_TAX_FORM.cgTTcardgroup.value = CardGroupName;
  LINK_CG_TERM_TAX_FORM.cgTTterminal.value = termName;
}

/**
 * Passes incoming data to the cardGroupListWidget function and calls the searchAvailableItems function.
 * 
 * @param {ICardGroupInsertUpdate} cardGroupData the card group list data
 */
export const getCardGroupData = (cardGroupData: Array<ICardGroupInsertUpdate>) => {
  cardGroupListWidget(cardGroupData, LINK_CG_TERMINAL_FORM.searchResults);

  searchAvailableItems(LINK_CG_TERMINAL_FORM.searchInput, LINK_CG_TERMINAL_FORM.searchResults);
}

/**
 * Passes incomng data to the terminalListWidget function and calls the searchAvailableItems function.
 * 
 * @param {ITerminal} terminalList the terminal list data
 */
export const getTerminalData = (terminalList: Array<ITerminal>) => {
  terminalListWidget(terminalList, LINK_CG_TERMINAL_FORM.searchResults);

  searchAvailableItems(LINK_CG_TERMINAL_FORM.searchInput, LINK_CG_TERMINAL_FORM.searchResults);
}

/**
 * Removes currently linked partner/customer(s) to individual card group
 * 
 * @param {string} accessElement array of elements
 * @param {any} id unique number for target element
 */
export const removePartnerCustomerAccess = (accessElement: string, id: any) => {
  let getAccessList = document.querySelector(accessElement) as HTMLElement;
  let removeEle = document.querySelector('.ele_access_' + id);
  let terminalId = getParameters('terminalID');
  let elementData: Array<any> = [];

  elementData.push({
    cardGroupId: +removeEle?.getAttribute('data-id')!,
    cardGroupName: removeEle?.getAttribute('data-name')!
  });

  if(!getAccessList) return;
  getAccessList.addEventListener('click', () => {
    cardGroupListWidget(elementData, LINK_CG_TERMINAL_FORM.searchResults);
    removeEle?.remove();
    addTerminalCardGroup(terminalId);    
  });
}